var _rect, _circle, _path, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FEF0C7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 33,
    r: 1,
    transform: "rotate(-180 28 33)",
    fill: "#998508"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.25 30C27.25 30.4142 27.5858 30.75 28 30.75C28.4142 30.75 28.75 30.4142 28.75 30H27.25ZM28.75 23C28.75 22.5858 28.4142 22.25 28 22.25C27.5858 22.25 27.25 22.5858 27.25 23H28.75ZM37.25 28C37.25 33.1086 33.1086 37.25 28 37.25V38.75C33.9371 38.75 38.75 33.9371 38.75 28H37.25ZM28 37.25C22.8914 37.25 18.75 33.1086 18.75 28H17.25C17.25 33.9371 22.0629 38.75 28 38.75V37.25ZM18.75 28C18.75 22.8914 22.8914 18.75 28 18.75V17.25C22.0629 17.25 17.25 22.0629 17.25 28H18.75ZM28 18.75C33.1086 18.75 37.25 22.8914 37.25 28H38.75C38.75 22.0629 33.9371 17.25 28 17.25V18.75ZM28.75 30L28.75 23H27.25L27.25 30H28.75Z",
    fill: "#998508"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#FFFAEB",
    strokeWidth: 8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomWarning);
export default __webpack_public_path__ + "static/media/custom-warning.0f36c754522386e663702db5c29c816e.svg";
export { ForwardRef as ReactComponent };